const affirmations = [
  {
    id: 1,
    text: "I am worthy of love and respect.",
    author: "Anonymous",
  },
  {
    id: 2,
    text: "I choose to focus on positivity today.",
    author: "Anonymous",
  },
  {
    id: 3,
    text: "I have the power to create change in my life.",
    author: "Anonymous",
  },
  {
    id: 4,
    text: "I let go of doubt and welcome confidence.",
    author: "Anonymous",
  },
  {
    id: 5,
    text: "My potential to succeed is limitless.",
    author: "Anonymous",
  },
  {
    id: 6,
    text: "I am grateful for the present moment.",
    author: "Anonymous",
  },
  {
    id: 7,
    text: "Challenges help me grow stronger every day.",
    author: "Anonymous",
  },
  {
    id: 8,
    text: "I believe in my dreams and abilities.",
    author: "Anonymous",
  },
  {
    id: 9,
    text: "Peace and calm flow through me with every breath.",
    author: "Anonymous",
  },
  {
    id: 10,
    text: "I am enough, just as I am.",
    author: "Anonymous",
  },
];

export default affirmations;
